import { render, staticRenderFns } from "./doordevicearea.vue?vue&type=template&id=478dd40e&scoped=true&"
import script from "./doordevicearea.vue?vue&type=script&lang=js&"
export * from "./doordevicearea.vue?vue&type=script&lang=js&"
import style0 from "./doordevicearea.vue?vue&type=style&index=0&id=478dd40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478dd40e",
  null
  
)

export default component.exports